import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';

@Component({
  selector: 'app-organization-chips',
  templateUrl: './organization-chips.component.html',
  styleUrl: './organization-chips.component.scss',
  standalone: false
})
export class OrganizationChipsComponent implements OnInit {
  @Input() selectedOrgs: any[] = [];  
  @Input() headerTitle: string = '';
  @Input() headerDescription: string = '';
  @Input() showHeader: boolean = false;
  @Output() removeOrg = new EventEmitter<any>();
  @Output() addOrg = new EventEmitter<void>();
  @Input() tooltip: string = '';
  @Input() organizations: any[] = [];

  faTimes = faTimes;
  isMaterialEnabled: boolean = false;
  parentCompanyName: string = '';

  constructor(private readonly storageService: StorageService) {}

  ngOnInit() {
    const selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    const preferences = this.storageService.getDataFromLocalStorage(StorageKeys.PREFERENCES);
    if (preferences?.material?.enabled) {
      this.isMaterialEnabled = true;
    }
    this.parentCompanyName = selfDetails?.assignedTo[0]?.parentCompanyName || '';
  }

  getParentCompanyName(org: any): string {
    if (org?.parentCompanyName) {
      return org.parentCompanyName;
    }
    if (this.organizations && this.organizations.length > 0 && org?.parentCompany) {
      const parent = this.organizations.find(o => o._id === org.parentCompany);
      if (parent) {
        return parent.name;
      }
    }
    return '';
  }

  onRemove(org: any) {
    this.removeOrg.emit(org);
  }

  onAdd() {
    this.addOrg.emit();
  }

  removeAll() {
    this.selectedOrgs.forEach(org => {
      this.removeOrg.emit(org);
    });
  }
}
